<!--  -->
<template>
  <div class="head-box">
    <div class="header">{{title}}</div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  },

  props: ['title'],

  watch: {},

  components: {},

  computed: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.head-box {
  .header {
   display: flex;
   align-items: center;
   text-align: left;
   color: #333333;
   font-size: 20px;
   line-height: 28px;
   font-weight: bold;
  }
   .header:before {
     width: 5px;
     height: 16px;
     border-radius: 2px;
     margin-right:20px;
     background: #FF789E;
     content:'';
     display: inline-block;
     vertical-align: center;
   }
}
</style>


// WEBPACK FOOTER //
// src/components/header/head.vue